import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../../components/Header/Header";
import Tabs from "../../../components/Tabs/Tabs";
import mes_tab_data from "../../../assets/mockedData/mes_tab_data";
import { savePathToLocalStorage } from "../../../utils/helpers";
import mesApi from "../../../Api/mes.api";
import { Trial, Product } from "../../../types/mes";
import { ToastContainer, toast } from "react-toastify";
import { formatTrialDate, getTrialId } from "./trialUtils";

const SavedTrials = () => {
  savePathToLocalStorage();

  const [trials, setTrials] = useState<Trial[]>([]);
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(false);
  const [filterStatus, setFilterStatus] = useState<string>("");
  const [filterProductId, setFilterProductId] = useState<number | null>(null);
  const [filterDateFrom, setFilterDateFrom] = useState<string>("");
  const [filterDateTo, setFilterDateTo] = useState<string>("");

  useEffect(() => {
    mesApi.getProducts().then(setProducts).catch(() => {});
  }, []);

  useEffect(() => {
    loadTrials();
  }, [filterStatus, filterProductId, filterDateFrom, filterDateTo]);

  const loadTrials = async () => {
    setLoading(true);
    try {
      const filters: Record<string, string | number> = {};
      if (filterStatus) filters.status = filterStatus;
      if (filterProductId) filters.product_id = filterProductId;
      if (filterDateFrom) filters.fromDate = filterDateFrom;
      if (filterDateTo) filters.toDate = filterDateTo;
      const data = await mesApi.getTrials(filters);
      setTrials(data);
    } catch (err: any) {
      toast.error("Greska pri ucitavanju pokusa: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  const getProductId = (p: Product) => p.ID;

  const getStatusLabel = (status: string) => {
    switch (status) {
      case "draft": return "Nacrt";
      case "confirmed": return "Potvrdjeno";
      case "completed": return "Zavrseno";
      case "promoted": return "Promovirano";
      default: return status;
    }
  };

  return (
    <div className="mes-page saved-trials-page">
      <Header title="MES - Spremljene probe" />
      <div className="main-content-flex">
        <Tabs data={mes_tab_data} />
        <div className="section mes-content">
          <div className="mes-section">
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "0.5rem" }}>
              <h3 style={{ margin: 0, border: "none", padding: 0 }}>Spremljene probe</h3>
              <Link to="/mes/trials/new" className="btn-primary">
                + Nova proba
              </Link>
            </div>
          </div>

          <div className="mes-section">
            <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap", alignItems: "flex-end" }}>
              <div className="control-group">
                <label>Status:</label>
                <select className="select-classic" value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)}>
                  <option value="">Svi statusi</option>
                  <option value="draft">Nacrt</option>
                  <option value="completed">Zavrseno</option>
                  <option value="promoted">Promovirano</option>
                </select>
              </div>
              <div className="control-group">
                <label>Proizvod:</label>
                <select
                  className="select-classic"
                  value={filterProductId || ""}
                  onChange={(e) => setFilterProductId(e.target.value ? Number(e.target.value) : null)}
                >
                  <option value="">Svi proizvodi</option>
                  {products.map((p) => (
                    <option key={getProductId(p)} value={getProductId(p)}>
                      {p.ProductName}
                    </option>
                  ))}
                </select>
              </div>
              <div className="control-group">
                <label>Od datuma:</label>
                <input type="date" className="input-classic" value={filterDateFrom} onChange={(e) => setFilterDateFrom(e.target.value)} />
              </div>
              <div className="control-group">
                <label>Do datuma:</label>
                <input type="date" className="input-classic" value={filterDateTo} onChange={(e) => setFilterDateTo(e.target.value)} />
              </div>
            </div>
          </div>

          {loading ? (
            <div className="mes-section loading-state">Ucitavanje...</div>
          ) : trials.length === 0 ? (
            <div className="mes-section empty-state">
              <p>Nema pokusa za odabrani filter.</p>
            </div>
          ) : (
            <div className="mes-section">
              <div className="mes-table-wrap">
                <table className="mes-table">
                <thead>
                  <tr>
                    <th>Kod</th>
                    <th>Datum</th>
                    <th>Proizvod</th>
                    <th>Status</th>
                    <th>Masa (kg)</th>
                    <th>Ocjena</th>
                    <th>Svrha</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {trials.map((trial) => (
                    <tr key={getTrialId(trial)}>
                      <td style={{ fontWeight: 600 }}>{trial.TrialCode || getTrialId(trial)}</td>
                      <td>{formatTrialDate(trial.TrialDate)}</td>
                      <td>{trial.Product_ProductToTrial?.ProductName || "-"}</td>
                      <td>
                        <span className={`status-pill status-${trial.Status}`}>
                          <span className="status-dot"></span>
                          {getStatusLabel(trial.Status)}
                        </span>
                      </td>
                      <td>{trial.DoughMassKg ?? "-"}</td>
                      <td>{(trial as any).final_score != null ? `${(trial as any).final_score}/10` : "-"}</td>
                      <td style={{ maxWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                        {trial.Purpose || "-"}
                      </td>
                      <td>
                        <Link to={`/mes/trials/${getTrialId(trial)}`} className="btn-sm btn-secondary">
                          Otvori
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              </div>
            </div>
          )}
        </div>
      </div>
      <ToastContainer position="bottom-right" autoClose={5000} theme="colored" />
    </div>
  );
};

export default SavedTrials;
